export class Payload {
    constructor(endpoint, method, payload) {
        this.endpoint = endpoint
        this.method = method, // GET, POST, PUT, DELETE
        this.payload = payload || {}
        this.headers = []
    }
    withCredentials(key, value) {
        this.headers.push({ key, value })
    }
}